import { createAsyncAction } from "../../helpers/actions"
import { passwordResetConfirm as api } from "../api/passwordResetConfirm"
import { PASSWORD_RESET_CONFIRM } from "../constants/ActionTypes"

export const passwordResetConfirm = createAsyncAction<
  string,
  [string, string, string, string]
>(PASSWORD_RESET_CONFIRM, api)
